enum TextStyleType {
  COLOR = "color",
  FONT = "font",
  DECORATION = "decoration",
  SIZE = "size",
  LINK = "link",
}

export default TextStyleType;
